import { HTTP } from './http-common'

let login = (username, password) => {
  let data = JSON.stringify({username: username, password: password})

  return HTTP.post('/api-token-auth', data, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  }).then((response) => {
    console.log(response)
    localStorage.setItem('access_token', response.data['token'])
    HTTP.defaults.headers.common['Authorization'] = 'JWT ' + localStorage.getItem('access_token')
    return {err: null, success: true}
  }).catch(err => {
    return {err: err, success: false}
  })
}

let logout = () => {
  localStorage.removeItem('access_token')
  delete HTTP.defaults.headers.common['Authorization']
}

let checkAuth = () => {
  if (localStorage.getItem('access_token')) {
    return true
  } else {
    return false
  }
}

let requireAuth = (to, from, next) => {
  if (!checkAuth()) {
    console.log('auth failed ...')
    let path = '/login'

    next({
      path: path
    })
  } else {
    next()
  }
}

let goHome = (to, from, next) => {
  if (checkAuth()) {
    let path = '/'

    next({
      path: path
    })
  } else {
    next()
  }
}

if (localStorage.getItem('access_token')) {
  HTTP.defaults.headers.common['Authorization'] = 'JWT ' + localStorage.getItem('access_token')
}

export default {
  checkAuth,
  login,
  logout,
  requireAuth,
  goHome
}



// WEBPACK FOOTER //
// ./src/auth.js